import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { DocumentIcon } from './AttachmentsField';

const CHIP = 'inline-flex max-w-full items-center gap-1.5 break-all text-left text-[14px] font-medium text-brand-600 no-underline transition hover:text-brand-700';

// Documents of a record: those of the service's Dropbox open in the platform (onOpen); older
// Dropbox links still open on dropbox.com until they are recovered.
const DocumentLinks = ({ documents = [], links = [], onOpen, size = 'md' }) => {
  const chip = size === 'sm' ? CHIP.replace('text-[14px]', 'text-[13px]') : CHIP;
  return (
    <ul className="m-0 flex list-none flex-col gap-1.5 p-0">
      {documents.map((item) => (
        <li key={item.id}>
          <button type="button" onClick={() => onOpen(item)} className={`${chip} cursor-pointer border-0 bg-[transparent] p-0`}>
            <DocumentIcon name={item.name} mimeType={item.mimeType} size={size === 'sm' ? 12 : 14} />
            {item.name}
          </button>
        </li>
      ))}
      {links.map((item, index) => (
        <li key={`${item.link}-${index}`}>
          <a href={item.link} target="_blank" rel="noopener noreferrer" className={chip}>
            <FiExternalLink size={size === 'sm' ? 12 : 13} aria-hidden="true" className="flex-none" />
            {item.name}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default DocumentLinks;
